import { useEffect, useMemo, useState } from "react";

/**
 * Keeps the profile modal state in the URL:
 *   ?profile=<id>&ptype=<leader|recruiter|prospect>
 *
 * API:
 *  const { id, type, openWithId, close } = useProfileModalRoute();
 *  openWithId("abc123","leader")
 */
export default function useProfileModalRoute() {
  const params =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : null;
  const idFromUrl = params?.get("profile") || "";
  const typeFromUrl = params?.get("ptype") || "";

  const [id, setId] = useState(idFromUrl);
  const [type, setType] = useState(typeFromUrl);

  useEffect(() => {
    const onPop = () => {
      const ps = new URLSearchParams(window.location.search);
      setId(ps.get("profile") || "");
      setType(ps.get("ptype") || "");
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const openWithId = (nextId, nextType) => {
    const ps = new URLSearchParams(window.location.search);
    if (nextId) ps.set("profile", nextId);
    else ps.delete("profile");
    if (nextType) ps.set("ptype", nextType);
    else ps.delete("ptype");
    const url = `${window.location.pathname}?${ps.toString()}${
      window.location.hash
    }`;
    window.history.pushState({}, "", url);
    setId(nextId || "");
    setType(nextType || "");
  };

  const close = () => {
    const ps = new URLSearchParams(window.location.search);
    ps.delete("profile");
    ps.delete("ptype");
    const url = `${window.location.pathname}${
      ps.toString() ? "?" + ps.toString() : ""
    }${window.location.hash}`;
    window.history.pushState({}, "", url);
    setId("");
    setType("");
  };

  return {
    id,
    type,
    openWithId,
    openWith: openWithId,
    open: openWithId,
    close,
  };
}
